import React from 'react';
import { MetricCardProps } from '@app-types/visualization';
import styles from './ChartMetricCard.module.css';

const ChartMetricCard: React.FC<MetricCardProps> = ({ value, title, description, color = '#3b82f6' }) => {
  return (
    <div className={styles.container}>
      <div className={styles.value} style={{ color }}>
        {String(value)}
      </div>
      <div className={styles.title}>{title}</div>
      {description && <div className={styles.description}>{description}</div>}
    </div>
  );
};

export default ChartMetricCard;
